import axios from 'axios';
export default axios.create({
  baseURL: "/",
  withCredentials: true,
  maxContentLength: 500000000,
});